import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE = "https://shillongmorningteerresulttoday.com";

export const LegalShell = ({ title, subtitle, breadcrumb = "Home", children }) => {
    return (
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-10">
            <nav className="text-xs text-slate-500 flex items-center gap-1.5" aria-label="Breadcrumb" data-testid="breadcrumb">
                <Link to="/" className="hover:text-blue-900">Home</Link>
                <ChevronRight className="h-3 w-3" />
                <span className="text-slate-700 font-semibold">{breadcrumb}</span>
            </nav>
            <div className="mt-4">
                <div className="text-xs uppercase tracking-widest text-yellow-600 font-semibold">Legal &amp; Info</div>
                <h1 className="font-display font-bold text-4xl md:text-5xl text-blue-950 tracking-tight mt-1">{title}</h1>
                {subtitle && <p className="text-slate-500 mt-2 text-base">{subtitle}</p>}
            </div>
            <article className="prose prose-slate max-w-none mt-8 leading-relaxed text-slate-700
                [&_h2]:font-display [&_h2]:tracking-tight [&_h2]:text-blue-950 [&_h2]:text-2xl [&_h2]:mt-8 [&_h2]:mb-3
                [&_h3]:font-display [&_h3]:tracking-tight [&_h3]:text-blue-950 [&_h3]:text-lg [&_h3]:mt-5 [&_h3]:mb-2
                [&_p]:mt-3 [&_p]:text-[15px]
                [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1
                [&_a]:text-blue-900 [&_a]:underline hover:[&_a]:text-blue-700
                [&_strong]:text-blue-950">
                {children}
            </article>
            <div className="mt-10 text-xs text-slate-400">
                Last updated: {new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })} · {SITE}
            </div>
        </div>
    );
};
